const viewerColorClasses = [
  'bg-green-700',
  'bg-red-700',
  'bg-yellow-700',
  'bg-blue-700',
  'bg-orange-700',
  'bg-violet-700',
  'bg-pink-700',
  'bg-rose-700',
]

const getViewerColorClass = (viewerIndex: number) =>
  viewerColorClasses[
    ((viewerIndex % viewerColorClasses.length) + viewerColorClasses.length) %
      viewerColorClasses.length
  ]

const getViewerLabel = (label: string | null) => label ?? 'Hidden user'

const getViewerInitials = (label: string | null) =>
  getViewerLabel(label).trim().slice(0, 2).toUpperCase()

export { getViewerColorClass, getViewerInitials, getViewerLabel }
